

























































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import sleep from "@/utils/sleep";
import SimbarDatePicker from "@/components/SimbarDatePicker.vue";
import api from "@/modules/common/api";

interface ResorvoirInfo {
    epoch: string;
    quota_flux: number;
    quota_downstream: number;
    water_gates: number[];
    time: string;
}

@Component({
    components: {
        SimbarDatePicker
    }
})
export default class ModalImporter extends Vue {
    /////////// Props ///////////
    @Prop({
        type: String,
        required: true
    })
    public readonly id!: string;

    @Prop({
        type: Number,
        required: true
    })
    public readonly source!: string;

    /////////// Data ///////////
    public busy: boolean = false;
    public loadingData: boolean = false;
    public datePoint: {
        value: string;
        isValid: boolean | null;
    } = {
        value: "",
        isValid: false
    };
    public data: ResorvoirInfo[] = [];
    public activeIndex: number = 0;
    public okTitle: string = "Importar";

    /////////// Getters ///////////
    public get activeData() {
        return this.data[this.activeIndex];
    }

    /////////// Methods ///////////
    @Emit("import-data")
    public confirm(event) {
        event.preventDefault();
        this.okTitle = "Importando...";
        this.busy = true;
        return {
            data: this.activeData,
            callback: async () => {
                let { epoch } = this.activeData;
                await this.$nextTick();
                (this.$refs.modalImporter as any).hide();
                this.reset();
                epoch = moment(epoch).format("DD/MM/YYYY HH:mm");
                this.$bvToast.toast(
                    `Dados do dia ${epoch} importados com sucesso.`,
                    {
                        title: "Aviso",
                        variant: "success",
                        noCloseButton: true
                    }
                );
            }
        };
    }

    public changeDate(datePoint) {
        this.datePoint.isValid = datePoint !== "" ? null : false;
        this.datePoint.value = datePoint;

        if (this.datePoint.isValid === null) {
            this.activeIndex = 0;
            this.updateData();
        }
    }

    public async updateData() {
        this.loadingData = true;

        const response = await api.getReservoirInfosByDay(
            this.source,
            this.datePoint.value
        );
        await sleep(500);
        this.data = (response.data as ResorvoirInfo[]).map(item => {
            item.time = moment(item.epoch).format("HH:mm");
            return item;
        });
        this.loadingData = false;
    }

    public reset() {
        this.busy = false;
        this.loadingData = false;
        this.datePoint.isValid = false;
        this.datePoint.value = "";
        this.data = [];
        this.activeIndex = 0;
        this.okTitle = "Importar";
    }
}
